import React from 'react';
import { Router } from '@reach/router';

import Dashboard from './Dashboard';
import User from './User';
import Container from './Container';

export default () => (
  <Container>
    <Router>
      <Dashboard path="/*" />
      <User path="user/*" />
    </Router>
  </Container>
);
